<template>
    <div>
        <AddCollaborator
            :markup="markup"
            :route="route"
            @created="e => collaboratorList = e"
        />

        <div class="list-group">
            <div v-if="collaboratorList.length >= 1">
                <Collaborator
                    v-for="collaborator in collaboratorList"
                    :key="collaborator.id"
                    @deleted="removeCollaborator"
                    :collaborator="collaborator"
                    :markup="markup"
                />
            </div>
            <div v-else class="text-center p-8 bg-info-subtle rounded-4">
                <h3>No Members yet.</h3>
                <p class="opacity-75 mt-3">Add colleagues using their email and set the permission level for accessing the project.</p>
                <img src="/img/undraw_collaboration_re_vyau.svg" class="w-50" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import Collaborator from './Collaborator.vue';
import AddCollaborator from './AddCollaborator.vue';

export default {
    components: {
        Collaborator,
        AddCollaborator,
    },
    props: [
        'collaborators',
        'markup',
        'route'
    ],
    data() {
        return {
            newList: [],
            collaboratorList: [],
        }
    },
    mounted() {
        this.collaboratorList = this.collaborators;
    },
    methods: {
        removeCollaborator(e) {
            let index = this.collaboratorList?.findIndex(function (collaborator) {
                return collaborator.id == e.id;
            })

            if (index != -1) {
                this.collaboratorList.splice(index, 1)
            }
        }
    },
    watch: {
        newList: {
            deep: true,
            immediate: true,
            handler: function (val, oldVal) {
                this.collaboratorList = val;
            }
        },
    },
}
</script>

<style scoped>
.collaborator-list {
    max-height: 20rem;
    overflow-y: scroll;
}
</style>
